let UserNewReward = require("clover/logic/userTask/UserNewReward")
var NewUserRewardPanel = require("clover/panel/NewUserRewardPanel")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var Panel = xClass("NewUserRewardWxSharePanel", NewUserRewardPanel, function () {
    return cc.CSLoader.createNode("cocos/new_user_reward_panel_newRewardPanel.csb")
})
Panel.prototype.itemPos = table([1, 2, table(
    [1, 1, table([0, 137 + 60], [0, -307])],
    [1, 2, table([0, 335 + 60], [0, -307])]
)], [1, 3, table(
    [1, 1, table([0, 55 + 60], [0, -307])],
    [1, 2, table([0, 237 + 60], [0, -307])],
    [1, 3, table([0, 427 + 60], [0, -307])]
)], [1, 4, table(
    [1, 1, table([0, 165 + 60], [0, -247])],
    [1, 2, table([0, 327 + 60], [0, -247])],
    [1, 3, table([0, 165 + 60], [0, -377])],
    [1, 4, table([0, 327 + 60], [0, -377])]
)])

Panel.prototype.ctor = function (onCloseCallback) {
    var self = this
    self.onCloseCallback = onCloseCallback

    if (META.platform == XcloverPlatform.wechatgame) {
        var um = UserManager.getInstance()
        var uid = um.getUserRef().uid
        if (uid % 2) {
            // A组
            self.isOpening = um.getSettingByKey('wechatGroupShareRewardsA')
        } else {
            // B组
            self.isOpening = um.getSettingByKey('wechatGroupShareRewardsB')
        }
    }

    NewUserRewardPanel.prototype.ctor.call(self, onCloseCallback)
}

Panel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)
    self.setScale(self.getReferenceScale())
    self.getChildByName("desc").setVisible(false)
    self.getChildByName("energybg").setVisible(false)
    let size = self.getContentSize()

    let bg = self.getChildByName("bg")
    self.width += 50
    bg.width += 50

    self.height += 50
    bg.height += 50

    let leaf = self.getChildByName("deco")
    leaf.setPositionX(leaf.getPositionX() + 30)

    self.closeBtn = cc.CSLoader.createNode("cocos/energy_panel_bottom_btn_close.csb")
    self.addChild(self.closeBtn)
    self.closeBtn.setPosition(self.width, bg.getPositionY())
    self.closeBtn.setAnchorPoint(0.25, 0.25)
    var close = UIGroupButton.create(self.closeBtn)
    ButtonPushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        if (self.closing) {
            return
        }
        self.closing = true

        UserNewReward.getInstance().getNewUserRewardsWx(function () {
            self.onClose()
        }, function (error) {
            Toast.make("网络异常请重试", null, function () {
                self.closing = false
            })
        })
    })

    var title = "分享到微信群"
    var titleLabel = cc.Label.createWithSystemFont(title, "Arial", 45, 400)
    titleLabel.setTextColor(cc.color(180, 119, 59, 255))
    titleLabel._setFontWeight("bold")
    titleLabel.setAnchorPoint(0.5, 0.5)
    titleLabel.setPosition(305, -153)
    self.addChild(titleLabel)

    let rewards
    if (self.B()) {
        rewards = $table([{ "itemId": 10006, "num": 1 }, { "itemId": 14, "num": 10 }])
    } else {
        rewards = $table([{ "itemId": 10021, "num": 1 }, { "itemId": 10006, "num": 1 }, { "itemId": 14, "num": 10 }])
    }
    self.rewards = rewards
    self.config = self.rewards

    var rewardCount = $len(self.rewards)
    var $limit27 = rewardCount
    for (var i = 1; i <= $limit27; i += 1) {
        var config = self.rewards[i]
        self.createRewardItem(i, config, rewardCount, 1.2)
    }

    // 底部文案
    let bottomText = cc.Label.createWithSystemFont("分享至群奖励加倍", "Arial", 35, 50)
    bottomText.setTextColor(cc.color(180, 119, 59, 255))
    // bottomText.setDimensions(400, 100)
    bottomText.setPosition(305, -470)
    bottomText.setAnchorPoint(0.5, 0.5)
    self.addChild(bottomText)

    var btn = self.getChildByName("getbtn")
    btn.setPositionY(btn.getPositionY() - 30)
    btn.setPositionX(btn.getPositionX() + 30)
    var label = btn.getChildByName("label")
    label.setAnchorPoint(cc.p(0.5, 0.5))
    label.setPosition(52, -5)
    // read from strings
    label.setString("去分享")
    self.getbtn = UIGroupButton.create(btn)
    PushBounceIdleBubbleAnim.create(self.getbtn)
    self.busy = false
    self.getbtn.on(UIButtonEvent.Click, function () {
        self.share()
    })
}

Panel.prototype.share = function () {
    let self = this

    if (self.busy) {
        return
    }

    self.busy = true
    // DCAssist.userTrack("newUserGiftbag", "click_share_btn")
    DCAssist.dc4ShareSend("newUserGiftbag", "click_share_btn")
    function onSuccess(code, msg, data) {
        cc.log("onSuccess code: " + code + ", msg: " + msg, data)
        cc.log(data)

        if (data.iv && data.encryptedData) {
            // DCAssist.userTrack("newUserGiftbag", "share_group_success")
            DCAssist.dc4ShareGroupOrSession("newUserGiftbag", "share_group_success", true)
            // 群分享，发送加五步请求
            UserNewReward.getInstance().getNewUserRewardsWx(function () {
                for (var k = 1, v = self.config[1]; v; k++ , v = self.config[k]) {
                    UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.NEW_USER_WX_SHARE)
                }
                self.playItemAnimation(function () {
                    self.onClose()
                })
            }, function (error) {
                Toast.make("网络异常请重试", null, function () {
                    self.closing = false
                })
            }, {
                    encryptedData: data.encryptedData,
                    iv: data.iv,
                    openid: data.openid,
                    sessionid: data.sessionid
                }
            )

        } else {
            // DCAssist.userTrack("newUserGiftbag", "share_personal_success")
            DCAssist.dc4ShareGroupOrSession("newUserGiftbag", "share_personal_success", false)
            Toast.make("只有分享至群奖励才会加倍哦~", null, function () {
                self.busy = false
            })
        }
    }
    function onFail(errCode) {
        Toast.make("分享失败", null, function () {
            self.busy = false
        })
    }
    function onCancel(result) {
        Toast.make("分享取消", null, function () {
            self.busy = false
        })
    }
    require("clover/utils/QQShareUtil")
    QQShareUtil.shareWechatgameNewUserGiftUrl(onSuccess, onFail, onCancel)
}

Panel.prototype.setCloseBtnVisible = function (visible) {
    let self = this
    if (self.closeBtn) {
        self.closeBtn.setVisible(visible)
    }
}

Panel.prototype.getReward = function () {
    var self = this
    if (!self.rewarded) {
        self.getbtn.setEnabled(false)
        self.playItemAnimation(function () {
            self.onClose()
            self.busy = false
        })
    } else {
        self.onClose()
    }
}

Panel.prototype.B = function () {
    var self = this
    let uid = UserManager.getInstance().uid
    return !(uid % 2) && self.isOpening
    // return true
}

Panel.prototype.isOpen = function () {
    var self = this
    return self.isOpening
    // return true
}
module.exports = Panel